/* ======================================================================
   SortimentPlus 3.3 – Suchvorschläge beim Tippen
   Nutzt Shopifys Predictive Search API (/search/suggest) mit der Section
   „predictive-search“. Ohne JavaScript funktioniert die normale Suche weiter.
   ====================================================================== */
(function () {
  'use strict';

  if (!window.fetch) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var instance = 0;

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function setup(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.dataset.predictiveReady === 'true') return;
    form.dataset.predictiveReady = 'true';
    instance += 1;

    var listId = 'PredictiveSearch-' + instance;
    var panel = document.createElement('div');
    panel.className = 'predictive-search';
    panel.id = listId;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Suchvorschläge');
    panel.hidden = true;
    form.classList.add('has-predictive-search');
    // Das Panel hängt am <body> und wird per position: fixed unter das Suchfeld gelegt,
    // damit es nicht von Elternelementen (overflow: hidden) abgeschnitten wird.
    document.body.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', listId);
    input.setAttribute('autocomplete', 'off');

    var controller = null;
    var activeIndex = -1;
    var lastTerm = '';

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    }

    function setActive(index) {
      var list = options();
      list.forEach(function (el, i) {
        var active = i === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      activeIndex = index;
      if (index >= 0 && list[index]) {
        // Eindeutige IDs je Suchfeld, da mehrere Suchfelder auf der Seite sind.
        if (!list[index].id || list[index].id.indexOf(listId) !== 0) list[index].id = listId + '-' + index;
        input.setAttribute('aria-activedescendant', list[index].id);
        list[index].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function position() {
      var rect = form.getBoundingClientRect();
      var width = Math.max(rect.width, Math.min(420, window.innerWidth - 16));
      var left = Math.min(rect.left, window.innerWidth - width - 8);
      panel.style.top = Math.round(rect.bottom + 8) + 'px';
      panel.style.left = Math.round(Math.max(8, left)) + 'px';
      panel.style.width = Math.round(Math.min(width, window.innerWidth - 16)) + 'px';
      panel.style.maxHeight = Math.max(200, Math.round(window.innerHeight - rect.bottom - 24)) + 'px';
    }

    function open() {
      if (!panel.innerHTML.trim()) return;
      position();
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      form.classList.add('is-predictive-open');
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      form.classList.remove('is-predictive-open');
      setActive(-1);
    }

    function render(html) {
      panel.innerHTML = html;
      // IDs aus der Section je Suchfeld eindeutig machen
      options().forEach(function (el, i) {
        el.id = listId + '-' + i;
      });
      activeIndex = -1;
      if (html.trim()) open();
      else close();
    }

    function search(term) {
      if (term === lastTerm && !panel.hidden) return;
      lastTerm = term;
      if (cache[term] !== undefined) {
        render(cache[term]);
        return;
      }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';
      form.classList.add('is-predictive-loading');
      fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search failed');
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var results = doc.querySelector('[data-predictive-results]');
          var html = results ? results.outerHTML : '';
          cache[term] = html;
          if (input.value.trim() === term) render(html);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          close();
        })
        .then(function () {
          form.classList.remove('is-predictive-loading');
        });
    }

    var onInput = debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) {
        lastTerm = '';
        close();
        return;
      }
      search(term);
    }, 220);

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML.trim()) open();
    });

    input.addEventListener('keydown', function (event) {
      var list = options();
      if (event.key === 'ArrowDown') {
        if (panel.hidden) open();
        if (!list.length) return;
        event.preventDefault();
        setActive(activeIndex + 1 >= list.length ? 0 : activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        if (!list.length) return;
        event.preventDefault();
        setActive(activeIndex - 1 < 0 ? list.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter') {
        if (!panel.hidden && activeIndex >= 0 && list[activeIndex]) {
          event.preventDefault();
          window.location.href = list[activeIndex].getAttribute('href');
        }
      } else if (event.key === 'Escape') {
        if (!panel.hidden) {
          event.preventDefault();
          close();
        }
      }
    });

    // Mausklick auf einen Vorschlag darf das Feld nicht vorher schließen.
    panel.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target) && !panel.contains(event.target)) close();
    });
    var reposition = function () {
      if (panel.hidden) return;
      var rect = form.getBoundingClientRect();
      // Suchfeld nicht mehr sichtbar (z. B. Menü geschlossen oder weggescrollt): schließen.
      if (rect.width === 0 || rect.bottom < 0) close();
      else position();
    };
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, { passive: true });
  }

  document.querySelectorAll('form[role="search"][action*="/search"]').forEach(function (form) {
    if (form.closest('.search-main') || form.closest('.empty-state')) return;
    setup(form);
  });
})();
